export default {
      id: "investment-plans-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#investment-plans",
      toString: function () {
        return this.url;
      }
    }